<template>
  <div>
    <myheader />
    <div class="vh60">
      <div align="center" class="col-12 b1 h3 mt-5">
        {{ $t("guid") }}
      </div>
      <div align="center" class="col-12 mt-5">
        {{ $t("guid1") }}
      </div>
    </div>
    <myfooter />
  </div>
</template>

<script>
import myheader from "../components/Share/Header.vue";
import myfooter from "../components/Share/Footer.vue";

export default {
  data() {
    return {};
  },
  components: { myheader, myfooter },
};
</script>
